import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import KeyboardReturnIcon from "@mui/icons-material/KeyboardReturn";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import {alpha} from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import type {ReactNode} from "react";
import {useTranslation} from "react-i18next";

/** Filled and quiet, unlike the bordered caps of the shared `PickerKeyboardHints`: this footer is the panel's own. */
export function KeyCap({children}: {children: ReactNode}) {
    return (
        <Box
            component="kbd"
            sx={{
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                minWidth: 24,
                height: 22,
                px: 0.75,
                borderRadius: 1,
                bgcolor: theme => alpha(theme.palette.text.primary, 0.05),
                color: "text.disabled",
                fontFamily: "inherit",
                lineHeight: 1,
                border: 0,
                "& .MuiSvgIcon-root": {fontSize: 14},
            }}
        >
            {children}
        </Box>
    );
}

/** ↑↓ navigate · insert ⏎ beneath the list. */
export function PickerFooterHints() {
    const {t} = useTranslation();

    return (
        <>
            <Divider/>

            <Stack
                direction="row"
                alignItems="center"
                justifyContent="space-between"
                gap={2}
                sx={{pl: 2, pr: 2.25, py: 1.25}}
            >
                <Stack direction="row" alignItems="center" gap={0.75}>
                    <KeyCap><ArrowUpwardOutlinedIcon fontSize="small"/></KeyCap>
                    <KeyCap><ArrowDownwardOutlinedIcon fontSize="small"/></KeyCap>
                    <Typography sx={{color: "text.secondary", fontSize: 12}}>{t("navigate")}</Typography>
                </Stack>
                <Stack direction="row" alignItems="center" gap={0.75}>
                    <Typography sx={{color: "text.secondary", fontSize: 12}}>{t("insert")}</Typography>
                    <KeyCap><KeyboardReturnIcon fontSize="small"/></KeyCap>
                </Stack>
            </Stack>
        </>
    );
}

export default PickerFooterHints;
